<template>
  <div id="root">
    <template v-if="!$route.meta.public">
      <v-app class="app" id="inspire">
        <app-header class="app-toolbar" ref="header"/>
        <v-main class="page-wrapper">
          <router-view/>
        </v-main>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <div>block</div>
          <router-view :key="$route.fullpath"/>
        </keep-alive>
      </transition>
    </template>

    <notifications
        position="bottom right"
        width="50%"
        ignoreDuplicates
        style="bottom: 6vh"
    />
  </div>
</template>

<script>

import AppHeader from "@/views/Header";

export default {
  name: 'App',
  components: {AppHeader},
  data: () => ({
    winsize: {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }),
  created() {
    window.app = this;
    console.warn('PROJECTID: ', process.env.VUE_APP_FB_PROJECTID)
    this.$router.push("/")
  },
  mounted() {
    window.onresize = () => {
      this.winsize.width = window.innerWidth;
      this.winsize.height = window.innerHeight;
    }
  }
};

</script>

<style lang="sass">

.app-style
  @if $theme == "staging"
    background-color: #1976d2 !important
  @else if $theme == "development"
    background-color: #465866 !important
  @else
    background-color: #66611e !important

</style>
